import dayjs from 'dayjs'

import type { DateInput } from '@fourthwall/utils/dist/timezone'
import { toDayjs } from '@fourthwall/utils/dist/timezone'

export const isBeforeNow = (date: DateInput) => toDayjs(date).isBefore(dayjs())

export const isSameDay = (dateA: DateInput, dateB: DateInput) =>
  toDayjs(dateA).isSame(toDayjs(dateB), 'days')

export const formatDate = (date: DateInput, dateFormat: string) => toDayjs(date).format(dateFormat)

export const getDaysLeft = (date: DateInput) => toDayjs(date).diff(dayjs(), 'days')

export const getHoursLeft = (date: DateInput) => toDayjs(date).diff(dayjs(), 'hours')
